export default __webpack_public_path__ + "c7f432e28978e1ee2d03dfd2e29c29c1.png";